function About() {
  return (
    <div>
      <p>
        Step into the ninja world and train your mind like a true shinobi! Every
        word you master is like learning a new jutsu, powering you up through
        the ninja ranks — from Genin all the way to Legendary Ninja.
      </p>
      <p>
        Defeat challenges with perfect scores, unlock your favorite Naruto
        characters, and prove you've got what it takes to become the strongest
        ninja in the village.
      </p>
      <p>Are you ready to rise to Hokage... and beyond? Believe it!</p>
    </div>
  );
}

export default About;
